<template>
  <div class="issueDetail">
    <el-menu
      class="el-menu-top"
      mode="horizontal"
      text-color="#000"
      active-text-color="#409EFF"
    >
      <el-menu-item class="tabActive">下发至桩</el-menu-item>
    </el-menu>
    <div class="issueDetail_table">
      <el-table
        ref="multipleTable"
        tooltip-effect="dark"
        :data="tableData"
        style="width: 100%;"
        max-height="90%"
        :header-cell-style="{
          color: 'rgba(255,255,255,1)',
          'font-weight': 'bold',
        }"
        class="public_tableColumn"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="checkSelectable"
        >
        </el-table-column>
        <el-table-column prop="ormtb602ca00" label="桩编号">
          <template slot-scope="scope">
            <p>
              <span
                :class="{
                  active_color_white: scope.row.ormtb602ca02 == '成功',
                }"
                >{{ scope.row.ormtb602ca00 }}</span
              >
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb601CA00" label="归属站点">
          <template slot-scope="scope">
            <p>
              <span
                :class="{
                  active_color_white: scope.row.ormtb602ca02 == '成功',
                }"
                >{{ scope.row.ormtb601CA00 }}</span
              >
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb602ca03" label="桩名称">
          <template slot-scope="scope">
            <p>
              <span
                :class="{
                  active_color_white: scope.row.ormtb602ca02 == '成功',
                }"
                >{{ scope.row.ormtb602ca03 }}</span
              >
            </p>
          </template>
        </el-table-column>
        <el-table-column prop="ormtb602ca02" label="下发状态">
          <template slot-scope="scope">
            <p>
              <span
                :class="[
                  scope.row.ormtb602ca02 == '失败'
                    ? 'active_color_red'
                    : 'active_color_blue',
                ]"
                >下发{{ scope.row.ormtb602ca02 }}</span
              >
            </p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pulbic_pagesize">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageMo"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="limitMo"
        layout="total,sizes, prev, pager, next"
        :total="pagingPageMo"
      >
      </el-pagination>
    </div>
    <!-- 提交按钮 -->
    <div class="submit_btns">
      <el-button class="submit_btns_left" @click="cancelForm">取消</el-button>
      <el-button type="primary" @click="submitForm">下发</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'issueDetail',
  data() {
    return {
      pageMo: 1, //默认列表页码
      limitMo: 10, //每页的条数
      pagingPageMo: 0, //分页--数据列表共有的条数
      tableData: [],
      multipleSelection: [],
    }
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  watch: {
    id: {
      handler(newVal) {
        this.getPileDetail()
      },
      immediate: true,
    },
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    checkSelectable(row, index) {
      return row.ormtb602ca02 == '失败'
    },
    // 获取下发桩详情
    getPileDetail() {
      var url = 'orm/ormtb602/selectDetailPageList'
      this.axios
        .post(url, {
          ormtb608id: this.id,
          page: this.pageMo,
          limit: this.limitMo,
        })
        .then(res => {
          if (res.data.code == 200) {
            this.tableData = res.data.data
            this.pagingPageMo = res.data.count
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {})
    },
    handleSizeChange(val) {
      this.pageMo = 1
      this.limitMo = 10
      this.getPileDetail()
    },
    // 点击页码
    handleCurrentChange(val) {
      this.pageMo = val
      this.getPileDetail()
    },
    cancelForm() {
      this.$emit('issueCancel')
    },
    submitForm() {
      let ormtb602ca00s = this.multipleSelection
        .map(item => item.ormtb602ca00)
        .join(',')
      var url = 'orm/ormtb608/issued'
      this.axios
        .post(url, { ormtb608id: this.id, ormtb602ca00s: ormtb602ca00s })
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            this.$emit('issueSubmit')
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {})
    },
  },
}
</script>
<style scoped>
.el-menu-top {
  border-bottom: 1px solid #cdcdcd !important;
}

.tabActive {
  position: relative;
  color: #199fff !important;
  font-size: 18px;
}

.tabActive::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #199fff;
}

.issueDetail_table {
  margin-top: 20px;
}

/* 提交按钮 */
.submit_btns {
  padding-top: 20px;
  display: flex;
  justify-content: end;
}

.submit_btns_left {
  color: #d9d9d9;
}

.active_color_red {
  color: #ff0000;
}

.active_color_blue {
  color: #199fff;
}

.active_color_white {
  color: #aaaaaa;
}
</style>
